// src/pages/partners/components/partner-card.tsx
import { Card, CardContent } from "@/components/ui/card";
import { Edit2, Trash2, Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { PermissionGuard } from "@/components/guards/PermissionGuard";

export function PartnerCard({ partner, onEdit, onDelete }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -4 }}
      transition={{ duration: 0.2 }}
    >
      <Card className="overflow-hidden h-full flex flex-col group hover:shadow-md transition-all duration-200 border-border/50 rounded-lg">
        {/* Partner Logo */}
        <div className="relative aspect-square overflow-hidden bg-gradient-to-br from-primary/10 to-primary/5">
          {partner.logoUrl ? (
            <img
              src={partner.logoUrl}
              alt={partner.name}
              className="w-full h-full object-contain p-8 transition-transform duration-500 group-hover:scale-110"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-muted-foreground">
              <Building2 className="w-24 h-24 opacity-20" />
            </div>
          )}
        </div>

        <CardContent className="p-5 flex-1 flex flex-col">
          {/* Partner Name */}
          <h3 className="font-semibold text-lg mb-4 text-center group-hover:text-primary transition-colors">
            {partner.name}
          </h3>

          {/* Spacer */}
          <div className="flex-1" />

          {/* Actions */}
          <div className="flex gap-2 pt-4 border-t border-border">
            <PermissionGuard resource="partners" action="update">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onEdit(partner)}
                className="flex-1"
              >
                <Edit2 className="w-4 h-4 mr-2" />
                Edit
              </Button>
            </PermissionGuard>
            <PermissionGuard resource="partners" action="delete">
              <Button
                variant="outline"
                size="sm"
                onClick={() => onDelete(partner)}
                className="hover:bg-destructive hover:text-destructive-foreground hover:border-destructive transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </PermissionGuard>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}